module.exports = __webpack_public_path__ + "static/media/add_question.3e0eb328.svg";